import ViewBase from "../../../framework/core/mvvm/view_base";
import Utility from "../../../utility/utility";
import AppData from "../../public/const/app_data";
import ModelData, { IUserData } from "../../public/model_data";
import CustomUIStateSwitcher from "../../public/ui/custom_ui_state_switcher";
import SpriteFrameHolder from "../../public/ui/spriteFrameHolder";
import { IUserCurrencyData } from "../../../manager/user_manager";
import GameUtil from "../../../utility/game_util";
import { club_utils } from "../club_utils";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ClubUserInfoView extends ViewBase {
    @property(cc.Label)
    userId:cc.Label = null;

    @property(cc.Sprite)
    avatar:cc.Sprite = null;

    @property(cc.Label)
    userName:cc.Label = null;

    @property(cc.Sprite)
    gender:cc.Sprite = null;

    @property(cc.Sprite)
    logo:cc.Sprite = null;

    @property(cc.Label)
    club_Id:cc.Label = null;

    @property(CustomUIStateSwitcher)
    customswitcher:CustomUIStateSwitcher = null;

    @property(SpriteFrameHolder)
    spriteHold:SpriteFrameHolder = null;

    @property(cc.Label)
    bankMoney:cc.Label = null;

    @property(cc.Label)
    clubMoney:cc.Label = null;

    @property(cc.Node)
    playerNode:cc.Node = null;

    @property([cc.Node])
    bankBoxNode:cc.Node[] = [];//0--隐藏 1--显示

    private _bankMoney:string = ''
    private _clubMoney:string = ''

    updateUserInfo(userInfo:IUserData){
        let isRole = ModelData.instance.roleData.id == userInfo.id
        this.customswitcher.SwitchState(isRole ? 'player':'other')
        this.userName.string = Utility.filterPlayerName(userInfo.name);
        this.userId.string = 'ID:'+userInfo.id;
        this.gender.spriteFrame = this.spriteHold.getSpriteFrameByKey('icon_' + userInfo.gender);
        this.club_Id.string = 'รหัสบัตรคลับ:' + ModelData.instance.clubId;
        this.avatar.spriteFrame = userInfo.avatarSprite;
    }

    updateUserMoney(userData:IUserCurrencyData,isShow:boolean){
        this.playerNode.active = isShow;
        if (isShow && userData) {
            this.refreshMoney(userData)
        }
    }

    
    updateLogo(style:number){
        this.logo.spriteFrame = this.spriteHold.getSpriteFrameByKey('logo_' + style);
    }

    private isNeedBring():boolean{
        if (AppData.gameSimpleName == "DZPK" || AppData.gameSimpleName == "SLOT") {
            return true;
        }
        return false;
    }


    private refreshMoney(userData:IUserCurrencyData){
        let gold = userData.chipClub;
        if (AppData.inTable) {
            if (this.isNeedBring()) {
                gold += userData.gameTableChip;
            }else{
                gold = userData.gameTableChip;
            }
        }else{
            if (!Number.isNaN(userData.freez)) {
                gold += Number(userData.freez);
            }
        }
        this._clubMoney = GameUtil.currencyFormatting(gold).toString();
        this.clubMoney.string = this._clubMoney
        this._bankMoney = GameUtil.currencyFormatting(userData.chipClubSafebox).toString();
        this.bankMoney.string = this._bankMoney;
        this.isShowBank(false);
    }


    isShowBank(isShow:boolean){//显示货币
        this.bankBoxNode[1].active = isShow;
        this.bankBoxNode[0].active = !isShow;
        !isShow ? this.bankMoney.string = '****':this.bankMoney.string = this._bankMoney;
        !isShow ? this.clubMoney.string = '****':this.clubMoney.string = this._clubMoney;
    }

}